<template>
  <div class="page">
    <div
      class="groups-query-list card"
      :class="{ '-loading': loading }"
    >
      <loader v-if="loading"></loader>

      <div class="header">
        <div class="description">
          <h2 class="title">Hitórico de Execuções da consulta recorrente "{{ recurrentHistorical.recurrent_name }}"</h2>
          <p class="subtitle">Nesta tela você visualiza as execuções da consulta recorrente.</p>
        </div>
      </div>

      <div
        class="body"
        :class="{ '-no-padding' : !errors.cantLoadList && !errors.cantLoadGroupQueriesList }"
      >
        <div class="alert -danger" v-if="errors.cantLoadList">
          <p class="title">Ops!</p>

          <p>
            Infelizmente aconteceu um erro ao tentar carregar suas consultas,
            por favor tente novamente ou contate nossa equipe.
          </p>
        </div>
        <div class="alert -danger" v-if="errors.cantLoadGroupQueriesList">
          <template slot="title">Ops!</template>

          <p>
            Infelizmente aconteceu um erro ao tentar exibir os detalhes,
            por favor tente novamente ou contate nossa equipe.
          </p>
        </div>

        <template v-if="!errors.cantLoadList">
          <table class="list">
            <thead>
            <tr class="-head">
              <th>Data de execução</th>
              <th>Valor</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="historical in recurrentHistorical.data">
              <tr
                class="row"
              >
                <td class="cell -queryinfo">{{ historical.created_at | dateFormat('DD/MM/YY HH:mm') }}</td>
                <td class="cell -queryinfo">R$  {{ historical.amount | currency }}</td>
              </tr>
            </template>
            <template v-if="recurrentHistorical.data.length === 0">
              <tr>
                <td colspan="2">Nenhum histórico encontrado.</td>
              </tr>
            </template>
            </tbody>
          </table>

          <div class="navList">
            <pagination
              :limit="1"
              :data="recurrents"
              @pagination-change-page="page = $event"
            >
              <span slot="prev-nav">Anterior</span>
              <span slot="next-nav">Próxima</span>
            </pagination>
          </div>
        </template>

        <router-link :to="{ name: 'Recurrent'}" class="btn btn-primary ml-6 mb-6">Voltar</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from 'laravel-vue-pagination';
import Loader from '@/support/components/Loader.vue';
import currency from '@/support/filters/currency';
import dateFormat from '@/support/filters/dateFormat';
import { mapState } from 'vuex';

export default {
  name: 'Historical',

  data() {
    return {
      loading: false,
      page: 1,
      errors: {
        cantLoadList: false,
      },
    };
  },

  methods: {
    async fetchList() {
      try {
        this.resetErrors();
        this.loading = true;

        await this.$store.dispatch(
          'recurrent/fetchHistorical',
          { page: this.page, id: this.$route.params.id },
        );
      } catch {
        this.errors.cantLoadList = true;
      } finally {
        this.loading = false;
      }
    },

    resetErrors() {
      this.errors.cantLoadList = false;
      this.errors.cantLoadGroupQueriesList = false;
    },
  },

  mounted() {
    this.fetchList();
  },

  computed: {
    ...mapState('recurrent', {
      recurrents: 'recurrents',
      periodicities: 'periodicities',
      recurrentHistorical: 'recurrentHistorical',
    }),
  },

  filters: {
    currency,
    dateFormat,
  },

  watch: {
    page() {
      this.fetchList();
    },
  },

  components: {
    Pagination,
    Loader,
  },
};
</script>

<style lang="scss" scoped>
.groups-query-list {
  > .body {
    > table.list {
      > thead,
      > tbody {
        > tr {
          > th,
          > td {
            padding-top: 0.8rem;
            padding-bottom: 0.8rem;

            .form-group {
              @apply mb-0;
            }

            &.-expanseaction {
              @apply text-center;
              @apply w-full;
              display: flex;
              justify-content: flex-end;
              gap: 8px;

              .btn {
                //padding: 0.2rem 0.5rem;

                > ion-icon {
                  left: 0;
                }
              }
            }
          }

          &.-head {
            @apply text-left;

            > .cell {
              @apply text-secondary-800;
              @apply text-xs;
              @apply font-bold;
            }
          }
        }
      }
    }

    > .navList {
      @apply flex;
      @apply justify-center;
    }
  }
}
</style>
